import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_AUTHENTICATED_ROUTE } from "../../../scaffolding/constants";
import { redirect } from "../../../scaffolding/router-api";

export const Route = createFileRoute("/_auth/_frame/")({
  beforeLoad: () => {
    throw redirect({
      to: DEFAULT_AUTHENTICATED_ROUTE,
      replace: true,
    });
  },
});
